var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../Button/ButtonGroup.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlButtonGroupSelect = props => {
    const { items, value, onChange, fullWidth } = props, rest = __rest(props, ["items", "value", "onChange", "fullWidth"]);
    const { layoutProps, inputProps } = extractLayoutProps(rest);
    const [selected, setSelected] = useState(value);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(ButtonGroup, Object.assign({ className: fullWidth ? 'w-full' : null }, inputProps), items.map(({ icon, text, value }) => (React.createElement(Button, { key: value, leadingIcon: icon, fullWidth: fullWidth, className: fullWidth ? 'flex-1' : null, disabled: selected && selected === value, onClick: () => {
                setSelected(value);
                if (typeof onChange !== 'undefined') {
                    onChange(value);
                }
            } }, text))))));
};
//# sourceMappingURL=FormControlButtonGroupSelect.js.map